import styles from "./saveModal.module.scss";
import okIcon from "../../shared/images/ok.svg";
import { ReactComponent as CloseIcon } from "../../shared/images/close.svg";
import { useTranslation } from "react-i18next";
import {
  useDispatch,
  useSelector
} from "react-redux";
import {
  AppDispatch,
  RootState
} from "../../store";
import {
  useEffect,
  useState
} from "react";
import { setUpdateModal } from "../../store/slices/mainSlice";

export const SaveModal = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch<AppDispatch>();

  const updateModal = useSelector((state: RootState) => state.mainSlice.updateModal);

  const [description, setDescription] = useState<string>("");

  useEffect(() => {
    if (updateModal.show) {
      setTimeout(() => {
        dispatch(setUpdateModal({ show: false, isDelete: false }));
      }, 3000)
    }
  }, [updateModal.show]);

  useEffect(() => {
    if (updateModal.isDelete) {
      setDescription(t("common.deletedSuccessfully"));
    } else {
      setTimeout(() => {
        setDescription(t("common.savedSuccessfully"));
      }, 300);
    }
  }, [updateModal.isDelete]);

  const closeModal = (): void => {
    dispatch(setUpdateModal({ show: false, isDelete: false }));
  }

  return (
    <div className={`${styles.container} ${updateModal.show ? styles.show : ""}`}>
      <div className={styles.message}>
        <img src={okIcon} alt=""/>
        {description}
      </div>
      <CloseIcon onClick={closeModal}/>
    </div>
  )
}